import { api } from '@/services/api';
import type { AuthResponse, LoginPayload, RegisterPayload } from '@/services/types';

export async function loginUser(payload: LoginPayload) {
  const response = await api.post<AuthResponse>('/auth/login', payload);
  return response.data;
}

export async function registerUser(payload: RegisterPayload) {
  const response = await api.post<AuthResponse>('/auth/register', payload);
  return response.data;
}
